import { NoSpacesString } from '@/types';
import { ReactNode } from 'react';

interface Props<T extends string> {
  className?: string;
  children?: ReactNode;
  childrenClassName?: string;
  dataCy?: NoSpacesString<T>;
  id?: string;
}

const Container = <T extends string>({
  className,
  children,
  id,
  childrenClassName,
  dataCy = 'container' as NoSpacesString<T>,
}: Props<T>) => {
  if (!children) {
    return null;
  }
  return (
    <div className={className} data-cy={dataCy} {...(id && { id })}>
      <div className={`container mx-auto min-h-[inherit] px-1 md:px-2 lg:px-4 ${childrenClassName ? childrenClassName : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default Container;
